'use client';
import React from 'react';

const Footer = () => {
  return (
    <footer
      className="relative text-[#ccc] pt-10"
      style={{
        backgroundColor: '#282828',
        backgroundImage: "url('/images/bg-body.png')",
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% auto',
      }}>
      <div className="relative container mx-auto px-4">
        {/* Footer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[2fr_1fr_1fr_1fr] gap-5 pb-8 border-b border-white/10">
          {/* Col 1: Org Info */}
          <div>
            <h3 className="text-[var(--accent,#f5a623)] text-base font-semibold uppercase mb-3">CỔNG THÔNG TIN ĐIỆN TỬ XÃ BẰNG LANG</h3>
            <div className="text-sm leading-[1.8] space-y-1">
              <p>Cơ quan chủ quản: UBND xã Bằng Lang, tỉnh Tuyên Quang</p>
              <p>
                <i className="fa-solid fa-location-dot text-[var(--accent,#f5a623)] mr-1.5" />
                Địa chỉ: Xã Bằng Lang, tỉnh Tuyên Quang
              </p>
              <p>
                <i className="fa-solid fa-phone text-[var(--accent,#f5a623)] mr-1.5" />
                Điện thoại: 02193.xxx.xxx
              </p>
              <p>
                <i className="fa-solid fa-envelope text-[var(--accent,#f5a623)] mr-1.5" />
                Email: banglang@tuyenquang.gov.vn
              </p>
            </div>
          </div>

          {/* Col 2: Quick links */}
          <div>
            <h4
              className="relative text-white text-[15px] font-semibold uppercase mb-3.5 pb-2
              after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-[30px] after:h-[2px] after:bg-[var(--primary,#1a6b3c)]">
              Liên kết nhanh
            </h4>
            <ul className="space-y-2">
              {[
                { href: '/', label: 'Trang chủ' },
                { href: '/gioi-thieu', label: 'Giới thiệu' },
                { href: '/tin-tuc', label: 'Tin tức' },
                { href: '/van-ban', label: 'Văn bản' },
                { href: '/lien-he', label: 'Liên hệ' },
              ].map((item) => (
                <li key={item.href}>
                  <a href={item.href} className="text-[#aaa] text-sm transition-all duration-200 hover:text-[var(--accent,#f5a623)] hover:pl-1.5">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Categories */}
          <div>
            <h4
              className="relative text-white text-[15px] font-semibold uppercase mb-3.5 pb-2
              after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-[30px] after:h-[2px] after:bg-[var(--primary,#1a6b3c)]">
              Chuyên mục
            </h4>
            <ul className="space-y-2">
              {[
                { href: '#', label: 'Hoạt động HĐND' },
                { href: '#', label: 'Kinh tế - Xã hội' },
                { href: '#', label: 'Nông thôn mới' },
                { href: '#', label: 'Du lịch' },
                { href: '#', label: 'Sản vật địa phương' },
              ].map((item) => (
                <li key={item.label}>
                  <a href={item.href} className="text-[#aaa] text-sm transition-all duration-200 hover:text-[var(--accent,#f5a623)] hover:pl-1.5">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Website links + Tin nhiem mang */}
          <div>
            <h4
              className="relative text-white text-[15px] font-semibold uppercase mb-3.5 pb-2
              after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-[30px] after:h-[2px] after:bg-[var(--primary,#1a6b3c)]">
              Liên kết website
            </h4>
            <ul className="space-y-2 mb-5">
              {[
                { href: 'https://tuyenquang.gov.vn', label: 'Cổng TTĐT tỉnh Tuyên Quang' },
                { href: 'https://chinhphu.vn', label: 'Chính phủ Việt Nam' },
                { href: 'https://quochoi.vn', label: 'Quốc hội Việt Nam' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#aaa] text-sm transition-all duration-200 hover:text-[var(--accent,#f5a623)] hover:pl-1.5">
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>

            <a
              href="https://tinnhiemmang.vn/danh-ba-tin-nhiem/van-phong-doan-dbqh-va-hdnd-tinh-ninh-binh-1626409153"
              rel="noopener noreferrer"
              target="_blank">
              <img alt="Chứng nhận tín nhiệm mạng" src="/chung-nhan.png" width={150} height="auto" />
            </a>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="text-center py-4 text-[13px] text-[#888]">
          <p>&copy; 2026 UBND Xã Bằng Lang - Tỉnh Tuyên Quang. Bản quyền thuộc UBND xã Bằng Lang.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
